<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div class="topology-general-info-container">
    <div
            *ngFor="let message of notificationService.messagesStack"
            class="alert alert-dismissible fade show {{ message.styleClass }}"
            role="alert"
    >
        <button (click)="notificationService.hideMessage(message.id)" aria-label="Close" class="close">
            <span aria-hidden="true">&times;</span>
        </button>
        <strong class="alert-msg">{{ message.text }}</strong>
    </div>

    <div
            *ngFor="let confirmation of confirmService.confirmNotificationStack"
            class="alert alert-dismissible fade show {{ confirmation.styleClass }}"
            role="alert"
    >
        <button (click)="confirmation.onConfirmResult(false)" aria-label="Close" class="close">
            <span aria-hidden="true">&times;</span>
        </button>

        <strong class="alert-msg"
        >{{ confirmation.text }}
            <br/>
            <ng-container *ngIf="confirmation.customActions; else yesNoBlock">
                    <span *ngFor="let action of confirmation.customActions; let i = index" class="d-flex align-items-baseline">
                        <button
                                (click)="doAction(confirmation, action)"
                                [ngStyle]="{ 'padding-top': i === 0 ? '15px' : '5px' }"
                                class="btn btn-link pl-0"
                        >
                            {{ action.text }}
                        </button>
                    </span>
            </ng-container>
            <ng-template #yesNoBlock>
                    <span class="d-flex align-items-baseline">
                        <button (click)="confirmation.onConfirmResult(true)" class="btn btn-link font-weight-bolder pl-0">
                            {{ confirmation.confirmActionText }}
                        </button>
                        /
                        <button (click)="confirmation.onConfirmResult(false)" class="btn btn-link font-weight-bolder">
                            {{ confirmation.declineActionText }}
                        </button>
                    </span>
            </ng-template>
        </strong>
    </div>
</div>
